var _class, _descriptor, _DialogHolder;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { notEq, or } from "truth-helpers";
import DButton from "discourse/components/d-button";
let DialogHolder = (_class = (_DialogHolder = class DialogHolder extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dialog", _descriptor, this);
  }
  async handleButtonAction(btn1) {
    if (typeof btn1.action === "function") {
      await btn1.action();
    }
    this.dialog.cancel();
  }
}, template(`
    <div
      aria-labelledby={{this.dialog.titleElementId}}
      aria-hidden="true"
      id="dialog-holder"
      class="dialog-container {{this.dialog.class}}"
    >
      <div class="dialog-overlay" data-a11y-dialog-hide></div>

      {{#if this.dialog.type}}
        <div class="dialog-content" role="document">
          {{#if this.dialog.title}}
            <div class="dialog-header">
              <h3 id={{this.dialog.titleElementId}}>{{this.dialog.title}}</h3>
              <DButton
                @action={{this.dialog.cancel}}
                @title="modal.close"
                @icon="times"
                class="btn-flat dialog-close close"
              />
            </div>
          {{/if}}

          {{#if (or this.dialog.message this.dialog.bodyComponent)}}
            <div class="dialog-body">
              {{#if this.dialog.bodyComponent}}
                <this.dialog.bodyComponent
                  @model={{this.dialog.bodyComponentModel}}
                />
              {{else if this.dialog.message}}
                <p>{{htmlSafe this.dialog.message}}</p>
              {{/if}}
            </div>
          {{/if}}

          {{#if (notEq this.dialog.type "notice")}}
            <div class="dialog-footer">
              {{#each this.dialog.buttons as |button|}}
                <DButton
                  @action={{fn this.handleButtonAction button}}
                  @translatedLabel={{button.label}}
                  @icon={{button.icon}}
                  class={{button.class}}
                />
              {{else}}
                <DButton
                  @action={{this.dialog.didConfirmWrapped}}
                  @icon={{this.dialog.confirmButtonIcon}}
                  @label={{this.dialog.confirmButtonLabel}}
                  @disabled={{this.dialog.confirmButtonDisabled}}
                  class={{this.dialog.confirmButtonClass}}
                />
                {{#if this.dialog.shouldDisplayCancel}}
                  <DButton
                    @action={{this.dialog.cancel}}
                    @label={{this.dialog.cancelButtonLabel}}
                    class={{this.dialog.cancelButtonClass}}
                  />
                {{/if}}
              {{/each}}
            </div>
          {{/if}}
        </div>
      {{/if}}
    </div>
  `, {
  component: _DialogHolder,
  eval() {
    return eval(arguments[0]);
  }
}), _DialogHolder), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleButtonAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleButtonAction"), _class.prototype)), _class);
export { DialogHolder as default };